// Makerscredit NV-handtekening: bij hover (muis/pen) of toetsenbordfocus schrijft de pen
// het monogram in volle kleur over de gedempte rustversie (snippets/nv-signature.liquid).
(() => {
  const EASE = "cubic-bezier(.4,0,.25,1)";
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  document.querySelectorAll("[data-nv-signature]").forEach((root) => {
    const ink = root.querySelector("[data-nv-ink]");
    const masks = Array.from(root.querySelectorAll("[data-nv-mask]"));
    if (!ink || masks.length === 0) return;

    const setMasks = (offset) => masks.forEach((m) => (m.style.strokeDashoffset = offset));
    let running = [];
    let active = false;
    const stop = () => {
      running.forEach((a) => a.cancel());
      running = [];
    };

    const enter = () => {
      if (active) return;
      active = true;
      stop();
      ink.style.transition = "none";
      ink.style.opacity = "1";
      if (reduce.matches || typeof masks[0].animate !== "function") {
        setMasks("0");
        return;
      }
      setMasks("1");
      running = masks.map((m) =>
        m.animate([{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }], {
          duration: Number(m.dataset.duration),
          delay: Number(m.dataset.delay),
          easing: EASE,
          fill: "both",
        }),
      );
      const current = running;
      Promise.all(current.map((a) => a.finished))
        .then(() => {
          if (running === current) {
            setMasks("0");
            stop();
          }
        })
        .catch(() => {});
    };

    const leave = () => {
      if (!active) return;
      active = false;
      ink.style.transition = "opacity 300ms ease";
      ink.style.opacity = "0";
    };

    root.addEventListener("pointerenter", (e) => {
      if (e.pointerType !== "touch") enter();
    });
    root.addEventListener("pointerleave", leave);
    root.addEventListener("focus", () => {
      if (root.matches(":focus-visible")) enter();
    });
    root.addEventListener("blur", leave);
  });
})();
